import axios from 'axios';

interface CompanyConfig {
  key: string;
  value: string | number | boolean;
}

interface CompanyConfigMap {
  [key: string]: string | number | boolean;
}

const pgoneAxios = axios.create();

const PGONE_CONFIG = {
  getUrl: () => `${window.location.protocol}//${window.location.host}/pgone-proxy`,
  version: 'v1',
  apiKey: 'pgsuiteone',
  apiSecret: '8bf8e3db-3c6a-49fd-a43d-7a9bfc82e9f1',
  username: process.env.REACT_APP_API_LOGIN || '',
  password: process.env.REACT_APP_API_PASSWORD || '',
};

export const getCompanyName = (): string => {
  const hostes = window.location.hostname.split('.');
  const companyName = hostes[0] || '';
  
  return companyName;
};

export const getAppMasterInfos = async (
  companyName: string,
  env: 'production' | 'preproduction' | 'development' = 'production'
): Promise<CompanyConfigMap> => {
  try {
    const url = `${PGONE_CONFIG.getUrl()}/${PGONE_CONFIG.version}/suiteoneconfig/${companyName.toLowerCase()}/fidone/${env}`;
    
    const response = await pgoneAxios.get<CompanyConfig[]>(url, {
      auth: {
        username: PGONE_CONFIG.username,
        password: PGONE_CONFIG.password,
      },
      headers: {
        'X-API-KEY': PGONE_CONFIG.apiKey,
        'X-API-SECRET': PGONE_CONFIG.apiSecret,
      },
    });

    const companyConfigs: CompanyConfigMap = {};
    if (Array.isArray(response.data)) {
      response.data.forEach((config: CompanyConfig) => {
        companyConfigs[config.key] = config.value;
      });
    }

    return companyConfigs;
  } catch (error) {
    console.error('Erreur lors de la récupération des configurations entreprise:', error);
    throw error;
  }
};

export const isModuleActive = (
  configs: CompanyConfigMap,
  moduleName: 'compte' | 'magasin' | 'offres' | 'factures'
): boolean => {
  const key = `module.${moduleName}.active`;
  return configs[key] === 1 || configs[key] === '1' || configs[key] === true;
};
